import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { HemroVerticalNavigationComponent } from '@hemro/components/navigation/vertical/vertical.component';
import { HemroNavigationService } from '@hemro/components/navigation/navigation.service';
import { HemroNavigationItem } from '@hemro/components/navigation/navigation.types';

@Component({
    selector       : 'hemro-vertical-navigation-divider-item',
    templateUrl    : './divider.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HemroVerticalNavigationDividerItemComponent implements OnInit, OnDestroy
{
    @Input() item: HemroNavigationItem;
    @Input() name: string;

    private _hemroVerticalNavigationComponent: HemroVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _hemroNavigationService: HemroNavigationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._hemroVerticalNavigationComponent = this._hemroNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._hemroVerticalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
